import { removeDupes } from '../utils/helpers';

const history = (state = {
    sources: [],
    history: [],
    fetchInfo: {
        sources: {
            fetched: false,
            loading: false
        },
        history: {
            fetched: false,
            loading: false
        }
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'BILLING_SOURCES_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    sources: {
                        ...state.fetchInfo.sources,
                        loading: true
                    }
                }
            });

        case 'BILLING_SOURCES_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                sources: removeDupes([
                    ...action.payload,
                    ...state.sources
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    sources: {
                        ...state.fetchInfo.sources,
                        loading: false,
                        fetched: true
                    }
                }
            });

        case 'BILLING_SOURCE_CREATE_SOCKET':
        case 'BILLING_SOURCE_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                sources: removeDupes([...state.sources, action.payload.source])
            });

        case 'BILLING_SOURCE_REMOVE_REQUESTED':
        case 'BILLING_SOURCE_REMOVE_SOCKET':
            return Object.assign({}, state, {
                sources: state.sources.filter(source => source.id !== action.payload.source)
            });

        case 'BILLING_HISTORY_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    history: {
                        ...state.fetchInfo.history,
                        loading: true,
                        fetched: false
                    }
                }
            });

        case 'BILLING_HISTORY_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                history: removeDupes([
                    ...action.payload,
                    ...state.history
                ], 'created_at'),
                fetchInfo: {
                    ...state.fetchInfo,
                    history: {
                        ...state.fetchInfo.history,
                        loading: false,
                        fetched: true
                    }
                }
            });

        default:
            return state;
    }
}

export default history;
